var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client",
    staticStyle: {
      "background-color": "white"
    }
  }, [(_vm.htdcontrollingflag == false) ? _c('div', [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(tab.value) + "\n\t\t\t"), (tab.value == 'Pending Waybills') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }) : _vm._e(), _vm._v(" "), (tab.value == 'Hub To Deliver Waybills') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    ref: "childViewComponent",
    tag: "component",
    staticClass: "tab",
    on: {
      "setcontrollingflag": _vm.setcontrollingflag
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.htdcontrollingflag == true) ? _c('div', [_c('p', {
    staticClass: "controllingnote"
  }, [_vm._v(_vm._s(_vm.hubname) + " Hub Is Not Controlling Hub")])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cd56d8","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/htdawblevelmarking/htdawblevelmarking.component.html
// module id = 1977
// module chunks = 3